<template>
    <div class="" style="padding-bottom: 100px;">
        <transition name="fade">
            <div class="container mt-4 content">
                <router-view>
                </router-view>
            </div>
        </transition>
        <Footer/>
    </div>
</template>

<script>
import Footer from '@/components/partials/Footer.vue';

    export default {
        name:"NotAuthLayout",
        components:{
            Footer
        }
    }
</script>